import * as React from 'react';

import type {EventFragmentFull as Event} from 'nutshell-graphql-types';

import {getEntryTypeFromPayload} from '../helpers';

import {TimelineBannerModal} from './timeline-banner-modal';

type Props = {
    event: Event;
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
};

export function TimelineModalOutreachSent(props: Props) {
    const {event} = props;
    if (event.payload && event.payload.__typename === 'Email') {
        const entity = event.payload;

        /**
         * In this case, we want to display the first recipient in the 'to' array
         * as the actor so the banner displays properly
         */
        const recipient =
            event.payload.recipients &&
            event.payload.recipients.length &&
            // @ts-expect-error
            event.payload.recipients[0].avatarEntity &&
            // @ts-expect-error
            event.payload.recipients[0].avatarEntity.__typename === 'Contact'
                ? // @ts-expect-error
                  event.payload.recipients[0].avatarEntity
                : undefined;

        const bodyHtml = event.payload.emailBodyHtml;

        if (recipient) {
            return (
                <TimelineBannerModal
                    isOpen={props.isOpen}
                    isLoading={props.isLoading}
                    onClose={props.onClose}
                    timestamp={event.changeTime}
                    // @ts-expect-error
                    actor={recipient}
                    entryType={getEntryTypeFromPayload(event.payload)}
                    changeType='ADDED'
                    entity={entity}
                    iconVariant='email-outreach-sent'
                    bodyHtml={bodyHtml}
                    isEdition={Boolean(entity.edition)}
                />
            );
        }
    }

    return null;
}
